import {Component, Input, OnInit} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {Contact} from "../../contact/contact";
import {GlobalValidators} from "../../validate/validate.globalvalidators";
import { EmailService } from 'service/email.service';

@Component({
    selector: 'ti-personaldata',
    templateUrl: './custom.ti.personaldata.component.html'
})
export class CusomTiPersonaldataComponent implements OnInit {

    /**
     * Formgroup for validating
     */
    @Input() form: FormGroup;

    /**
     * Handling for the contact data
     */
    @Input() contact: Contact;

    /**
     * OPtions for the remarks list
     */
    remarksOptions: {name: string}[] = [
        {name: 'Berichterstattung in den Medien'},
        {name: 'Internet allgemein'},
        {name: 'Arbeitsumfeld'},
        {name: 'Eigenrecherche'},
        {name: 'Persönliche Kontakte'},
        {name: 'Veranstaltungen'},
        {name: 'Newsletter'}
    ];

    /**
     * Options for the interest list
     */
    interestsOptions: {name: string}[] = [
        {name: 'Digitalisierung'},
        {name: 'Politische Bildung'},
        {name: 'Finanzwesen'},
        {name: 'Sport'},
        {name: 'Hinweisgeber'},
        {name: 'Staatliche Entwicklungszusammenarbeit'},
        {name: 'Internationale Vereinbarungen'},
        {name: 'Strafrecht/Justiz'},
        {name: 'Kirchliche Entwicklungszusammenarbeit'},
        {name: 'Vergabe'},
        {name: 'Kommunen'},
        {name: 'Verwaltung'},
        {name: 'Medien'},
        {name: 'Wirtschaft'},
        {name: 'Medizin und Gesundheit'},
        {name: 'Wissenschaft'},
        {name: 'Politik'},
    ]

    /**
     * @constructor
     */
    constructor(private emailService: EmailService) {}

    /**
     * is called when initialising the component
     */
    public ngOnInit(): void {
        this.form.addControl('email', new FormControl('', [Validators.required, GlobalValidators.validateEmail]));
        this.form.addControl('firstname', new FormControl('', [Validators.required]));
        this.form.addControl('lastname', new FormControl('', [Validators.required]));
        this.form.addControl('postal_code', new FormControl('', [Validators.required, GlobalValidators.validateGermanPostalCode]));
        this.form.addControl('city', new FormControl('', [Validators.required]));
        this.form.addControl('street', new FormControl('', [Validators.required]));
        this.form.addControl('telephone', new FormControl());
        this.form.addControl('company', new FormControl());
        this.form.addControl('job', new FormControl());
        this.form.addControl('birthday', new FormControl('', [GlobalValidators.validateBirthday]));
        this.form.addControl('remarks', new FormControl('', [Validators.required]));
        this.form.addControl('interest', new FormControl('', [Validators.required]));
        this.form.addControl('share_internal', new FormControl());
        this.form.addControl('reason_for_participation', new FormControl('', [Validators.required]));
        this.form.addControl('association_work', new FormControl('', [Validators.required]));

        // preset magazin
        this.contact.data.additional['magazin_print'] = true;
    }

    /**
     * Returns if a field is invalid
     * @param field
     * @returns {boolean}
     */
    isFieldInvalid(field: string): boolean {
        return this.form.controls[field].touched == true && this.form.controls[field].invalid == true;
    }

    /**
     * Returns the label textkey of a field, depending of it is valid or not
     * @param field
     * @returns {string}
     */
    getLabelKeyForField(field: string): string {
        return this.isFieldInvalid(field)? 'contact.' + field + '.label.error' : 'contact.' + field + '.label';
    }

    /**
     * updates the remarks model with the values from the additional data in the contact
     */
    setField(fieldName: string): void {
        const fieldData = Object.keys(this.contact.data.additional).filter(key => key.match(new RegExp('^' + fieldName)) && this.contact.data.additional[key]).map(key => this.contact.data.additional[key]);
        this.form.get(fieldName).setValue(fieldData.join(","));
    }

    /**
    * fix the email address typos
    */
    correctEmailAddress() {
        // get the email address
        const email = this.form.controls['email'].value;

        // fix the email address
        const correctedEmail = this.emailService.correctEmailAddress(email);

        // set the corrected email address
        this.form.controls['email'].setValue(correctedEmail);
        this.contact.data.email = correctedEmail;
    }
}
